import React from 'react';
import { IconProps } from '../IconProps';
const SvgCheckNoBorder = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 14 13" fill="none" {...props}>
    <path
      d="M4.75 12.5h-.002a.751.751 0 01-.584-.281l-4-5a.75.75 0 011.172-.938l3.418 4.273L12.667.778a.75.75 0 011.166.944l-8.5 10.5a.749.749 0 01-.583.278z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgCheckNoBorder;
